import { makeBetterEnum } from './betterEnum';

export const ReportAttachmentItemDocumentType = makeBetterEnum(
  'ReportAttachment',
  'RiskAssessment'
);

export type ReportAttachmentItemDocumentType =
  (typeof ReportAttachmentItemDocumentType)[keyof typeof ReportAttachmentItemDocumentType];

export const EsgReportDestinationOption = makeBetterEnum(
  'EsgTcfdOwnWebsite',
  'CDP',
  'EDCI',
  'Other',
  'NoReport'
);

export type EsgReportDestinationOption =
  (typeof EsgReportDestinationOption)[keyof typeof EsgReportDestinationOption];
